import axios from 'axios'
import { Cookies } from '@/shared/helpers/Cookies'

export abstract class ApiHandler {
  private static interceptorsSetup = false

  private static setupInterceptors() {
    if (this.interceptorsSetup) return

    axios.interceptors.request.use((config) => {
      const token = Cookies.get('authToken')
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
      return config
    })

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          const cookieOptions = {
            domain: window.location.hostname,
            path: '/',
          }
          Cookies.remove('userId', cookieOptions)
          Cookies.remove('authToken', cookieOptions)
          window.location.href = '/'
          return Promise.reject(error)
        }
        return Promise.reject(error)
      },
    )

    this.interceptorsSetup = true
  }

  public static get(path: string, parameters: any = null): Promise<any> {
    return this.request('GET', path, parameters)
  }

  public static post(path: string, parameters: any, isFormData?: boolean): Promise<any> {
    return this.request('POST', path, parameters, isFormData)
  }

  public static patch(path: string, parameters: any, isFormData?: boolean): Promise<any> {
    return this.request('PATCH', path, parameters, isFormData)
  }

  public static delete(path: string, parameters: any): Promise<any> {
    return this.request('DELETE', path, parameters)
  }

  public static request(
    method: 'GET' | 'POST' | 'DELETE' | 'PATCH',
    path: string,
    parameters: any,
    isFormData?: boolean,
  ): Promise<any> {
    this.setupInterceptors()

    return new Promise<any>((resolve, reject) => {
      const baseURL = 'https://dt.softwarecenter.ru/api/v2/'
      const config: any = {
        method,
        url: `${baseURL}${path}`,
      }

      if (method === 'GET') {
        if (parameters && Object.keys(parameters).length) {
          config.params = parameters
        }
      } else {
        let hasFile = false
        if (parameters) {
          for (const key of Object.keys(parameters)) {
            const value = parameters[key]
            if (typeof window !== 'undefined' && 'File' in window && value instanceof File) {
              hasFile = true
              break
            }
          }
        }

        let data: any = null

        if (hasFile) {
          const formData = new FormData()
          for (const key of Object.keys(parameters)) {
            const value = parameters[key]
            if (value !== null && value !== undefined) {
              formData.append(key, value)
            }
          }
          data = formData
        } else if (isFormData) {
          data = parameters
          config.headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
        } else if (parameters && Object.keys(parameters).length) {
          data = {}
          for (const key of Object.keys(parameters)) {
            const value = parameters[key]
            if (value !== null && value !== undefined) {
              data[key] = value
            }
          }
          config.headers = { 'Content-Type': 'application/json' }
        }

        config.data = data
      }

      axios(config)
        .then((response) => {
          const responseObj: any = response.data
          if (!responseObj.message) {
            resolve(responseObj)
          } else {
            reject(responseObj)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}